module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Anderson_Brenda.ef3d7fd2.jpg";